export const size = {
  $large: '1440px',
  $medium: '1260px',
  $small: '740px',

  $container: '1264px',
  $containerTablet: '720px',
  $containerMobile: '288px',

  $indent: '24px',
  $indentBig: '32px',
  $indentSmall: '16px',
  $indentBigMobile: '36px',
  $indentSection: '128px',
  $indentSectionTablet: '76px',
  $indentSectionMobileBig: '64px',
};

// Colors
export const colors = {
  $colorWhite: '#ffffff',
  $colorBlueAc700: '#1A56DB',

  $darkPrimary: '#3E545C',
  $colorDarkPrimary150: '#DBDFE0',
  $colorDarkPrimaryDp200: '#B7BFC2',
  $colorDarkDp400: '#9fa9ad',
  $colorDarkDp500: '#869499',

  $colorBlack: '#0e2933',

  $colorBlackSolid: '#000',
  $colorBlack800: '#111928',

  $colorGrayBeta800: '#1F2A37',
  $colorGray50: '#F9FAFB',
  $colorGrayAc100: '#F3F4F6',
  $colorGrayAc200: '#E5E7EB',
  $colorGrayDP200: '#CFD4D6',
  $colorGraay500: '#6b7280',

  $colorBlue400: '#1c80e4',

  $colorSkyBlue: '#A4CAFE',

  $colorYellow300: '#c3800d',
  $colorYellowAc50: '#FDFDEA',

  $colorOrange50: '#FFF8F1',
  $colorOrange400: '#FF8A4C',

  $colorIndigo50: '#F0F5FF',
  $colorIndigo300: '#B4C6FC',

  $colorTeal50: '#EDFAFA',
  $colorTeal300: '#7EDCE2',

  $colorRed50: '#c42014',
  $colorRed500TrashIcon: '#F05252',

  $colorIconError: '#e02424',

  $accentColor: '#065EC5',
  $accentColor50: '#F3F7FC',
  $accentColor100: '#E6EFF9',
  $accentColor800: '#387ED1',
  $transparent: 'transparent',

  $colorPink400: '#F17EB8',
  $colorTeal400: '#16BDCA',
  $colorPurpleBg400: '#ac94fa',

  $colorGrayDp100: '#e7eaeb',

  $tooltipBgColor: '#191918',
  $colorPurple600: '#7E3AF2',
  $colorGrayCc500: '#f6f6f5',
  $colorMuiPrimary: '#1976d2',
  $colorPrimaryBlack100: '#e7e7e6',
  $colorPrimary500: '#706F69',
  $colorGreen500: '#0e9f6e',
};

// Durations
export const transitions = {
  $transitionDuration: '0.4s',
};
